module.exports = __webpack_public_path__ + "static/media/Selected.cd5f3d3d.png";